<template>

    <v-card >
      <v-div v-if="ppa_precio_compra_matrix.length<=0">
        <v-card-title>{{$t('simulacion.modulo.ppa_configuracion.titulo')}}</v-card-title>
        <v-divider></v-divider>
      </v-div>
        <v-card-text>
            <v-row v-if="ppa_precio_compra_matrix.length>0">
              <!-- Nueva implementación, valor anual de compra por cada PPA -->
              <v-col cols="12" md="12" class="pr-md-2">
                <v-card-title>
                  {{ $t('simulacion.modulo.ppa_configuracion.pcio_compra') }}
                </v-card-title>
                <div class="subtitulo-PPA pr-md-2"><em>{{ $t('simulacion.modulo.ppa_configuracion.mensaje_check') }}</em></div>
                <v-divider></v-divider>
                <v-col cols="12" class="d-flex justify-end mb-2">
                <v-btn  color="primary" class="mx-2" @click="exportToCSV('compra')" :disabled=false>
                  {{$t('comun.boton_exportar')}} {{$t('simulacion.modulo.ppa_configuracion.pcio_compra')}}
                </v-btn>
                
                <v-btn :disabled="this.disabled" color="primary" class="mx-2" @click="importFromCSVCompra">
                  {{$t('comun.boton_importar')}} {{$t('simulacion.modulo.ppa_configuracion.pcio_compra')}}
                  <input
                    type="file"
                    accept=".csv"
                    ref="fileInputCompra"
                    style="display: none;"
                    @change="handleCSVUpload($event,'compra')"
                  />
                </v-btn>
                </v-col>
                <!-- TABLA 1: Valores límite -->
                <div class="scroll-container">
                  
                <div class="">
                  <table class="tabla-estilizada">
                    <thead>
                      <tr>
                        <th v-for="col in columns_compra" :key="col.prop" :style="{ width: col.w }">
                          <div class="th-wrap">{{ col.name }}</div>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(fila, index) in datos_compra.filter(d => {
                              const fecha_Str=d.anio.toString()
                                const partes = fecha_Str.split('-');
                                const anio = parseInt(partes[0]);
                                let mes = parseInt(partes[1]);
                                //Si no existe el mes en las partes separadas, se asigna a 1 para que el modo anual funcione tambien
                                // Legacy, cuando se usaba ANIO_PPA_INI y ANIO_PPA_FIN
                                let anioFin
                                let anioInicio
                                if (this.ejecucion && 'ANIO_PPA_INI' in this.ejecucion){
                                   anioInicio = this.ejecucion.ANIO_PPA_INI;
                                   anioFin = this.ejecucion.ANIO_PPA_FIN;
                                }
                                else{
                                   anioInicio = this.datos_generales.anio_inicio;
                                   anioFin = this.datos_generales.anio_fin;
                                }
                                // const anioInicio = this.ejecucion.ANIO_PPA_INI;
                                // const anioFin = this.ejecucion.ANIO_PPA_FIN;
                                const mesInicio = datos_generales.mes_inicio;
                              
                                // Filtra por año dentro del rango
                                if (anio < anioInicio || anio > anioFin) return false;
                                
                                if (mes){
                                  
                                  // Si es el primer año, aplica también el filtro de mes
                                  if (anio === anioInicio && mes < mesInicio) return false;
                                  
                                  // Si es el íltimo año, aplica el filtro del mes a la inversa
                                  if (anioInicio!=anioFin &&  anio === anioFin && mes >= mesInicio) return false;
                                }
                                return true;
                              })"
                              :key="index">
                        <td>{{ fila.anio }}</td>
                        <td>
                          <div style="display: flex; align-items: center; gap: 5px;">
                          <input :disabled="disabled" type="text"
                                :value="formatNumber(fila.ppa1)"
                                @input="e => { const v=e.target.value.replace(',', '.'); fila.ppa1=Number(v); validarCampo(fila,'ppa1'); }"
                                class="campo"
                                
                                 />
                                
                            <!-- Añadir PPA1 activo para ese año si no estamos en la versión antigua  -->
                            <div v-if="this.ejecucion && !('ANIO_PPA_INI' in this.ejecucion)">
                             <input
                                :disabled="disabled"
                                type="checkbox"
                                v-model="fila.activo1"
                                :true-value="1"
                                :false-value="0"
                              />    
                           </div>   
                           </div>  
                        </td>
                        <td>
                          <div style="display: flex; align-items: center; gap: 4px;">
                          <input :disabled="disabled" type="text"
                                :value="formatNumber(fila.ppa2)"
                                @input="e => { const v=e.target.value.replace(',', '.'); fila.ppa2=Number(v); validarCampo(fila,'ppa2'); }"
                                class="campo"/>
                          <!-- Añadir PPA2 activo para ese año si no estamos en la versión antigua  -->
                          <div v-if="this.ejecucion && !('ANIO_PPA_INI' in this.ejecucion)">
                             <input
                                :disabled="disabled"
                                type="checkbox"
                                v-model="fila.activo2"
                                :true-value="1"
                                :false-value="0"
                              />    
                           </div>
                           </div>   
                        </td>
                        <td>
                          <div style="display: flex; align-items: center; gap: 4px;">
                          <input :disabled="disabled" type="text"
                                :value="formatNumber(fila.ppa3)"
                                @input="e => { const v=e.target.value.replace(',', '.'); fila.ppa3=Number(v); validarCampo(fila,'ppa3'); }"
                                class="campo"/>
                          <!-- Añadir PPA3 activo para ese año si no estamos en la versión antigua  -->
                          <div v-if="this.ejecucion && !('ANIO_PPA_INI' in this.ejecucion)">
                             <input
                                :disabled="disabled"
                                type="checkbox"
                                v-model="fila.activo3"
                                :true-value="1"
                                :false-value="0"
                              />    
                           </div>
                           </div>
                        </td>
  
                      </tr>
                    </tbody>
                  </table>
                </div>
                </div>
              </v-col>
              </v-row>
              <v-row v-else>
            <v-col cols="12">

              <v-container>
                Config
                <v-form v-model="valid" lazy-validation>
                  <!-- LEGACY: Forma antigua, precio estático de compra para cada PPA -->
                  <v-data-table
                    :headers="headers"
                    :items="datos"
                    item-value="tipo"
                    class="elevation-1"
                    hide-default-footer
                  >
                    <!-- Slot para las celdas editables 
                    <template v-slot:[`item.capmax`]="{ item }">
                      <v-text-field
                        v-model.number="item.capmax"                        
                        @input="emitChanges"
                      ></v-text-field>
                    </template>
                    -->
                    <template v-slot:[`item.pcio`]="{ item }">
                      <v-text-field
                        :model-value="formatNumber(item.pcio)"
                        @update:modelValue="val => item.pcio = Number(val.replace(',', '.'))"                                              
                        @input="emitChanges"
                        :rules="[rules.Negativo]"
                      ></v-text-field>
                    </template>

                      <template v-slot:[`item.pcio_venta`]="{ item }">                            
                        <v-text-field
                          :model-value="formatNumber(item.pcio_venta)"
                          @update:modelValue="val => item.pcio_venta = Number(val.replace(',', '.'))"                                              
                          @input="emitChanges"
                          :rules="[rules.Negativo]"
                        ></v-text-field>                        
                      </template>
                    


                    <template v-slot:[`item.horas`]="{ item }">
                      <!--<label>{{ item.horas }}</label>-->
                      <label>{{ formatNumber(calcular_horas(item)) }}</label>
                      <!--<v-text-field
                        v-model.number="item.horas"                        
                        @input="emitChanges"
                        readonly
                      ></v-text-field>
                      -->
                    </template>

                    <template v-slot:[`item.cppafija`]="{ item }">
                      <v-text-field
                        v-model.number="item.cppafija"                        
                        @input="emitChanges"
                      ></v-text-field>
                    </template>


                  </v-data-table>
                  

                </v-form>
                 </v-container>


            </v-col>
            </v-row>
        </v-card-text>
  <v-card>
 
  <v-row v-if="this.ejecucion.OPC_PCPPA === 1 & this.datos_excedente.length>0" class="mt-2" align="start" no-gutters>

    
    <!-- Venta excedente PPA -->
  <v-col cols="12" md="12" class="pr-md-2">
    <v-card-title>
      {{ $t('simulacion.modulo.ppa_configuracion.pcio_venta') }}
    </v-card-title>
    <v-divider></v-divider>
    <v-row class="mt-2 mb-2">
          <v-col cols="12" md="6">
            <v-switch
              :disabled="disabled"
              :model-value="modoMinPoolExcedente"
              @update:modelValue="actualizarModoPcvppa"
              inset
              color="primary"
              hide-details
              :label="labelModoPcvppa"
            />
          </v-col>
        </v-row>
    <v-col cols="12" class="d-flex justify-end mb-2">
                <v-btn  color="primary" class="mx-2" @click="exportToCSV">
                  {{$t('comun.boton_exportar')}} {{$t('simulacion.modulo.ppa_configuracion.pcio_venta')}}
                </v-btn>
                
                <v-btn :disabled="this.disabled" color="primary" class="mx-2" @click="importFromCSVVenta">
                  {{$t('comun.boton_importar')}} {{$t('simulacion.modulo.ppa_configuracion.pcio_venta')}}
                  <input
                    type="file"
                    accept=".csv"
                    ref="fileInputVenta"
                    style="display: none;"
                    @change="handleCSVUpload($event, 'venta')"
                  />
                </v-btn>
              </v-col>
<!-- TABLA 1: Valores límite -->
    <div class="scroll-container">
    <div class="">
      <table class="tabla-estilizada">
        <thead>
          <tr>
            <th v-for="col in columns_excedente" :key="col.prop" :style="{ width: col.w }">
              <div class="th-wrap">{{ col.name }}</div>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(fila, index) in datos_excedente.filter(d => {
                   const fecha_Str=d.anio.toString()
                     const partes = fecha_Str.split('-');
                    const anio = parseInt(partes[0]);
                    let mes = parseInt(partes[1]);
                    //Si no existe el mes en las partes separadas, se asigna a 1 para que el modo anual funcione tambien
                    let anioFin
                    let anioInicio
                    if (this.ejecucion && 'ANIO_PPA_INI' in this.ejecucion){
                        anioInicio = this.ejecucion.ANIO_PPA_INI;
                        anioFin = this.ejecucion.ANIO_PPA_FIN;
                    }
                    else{
                        anioInicio = this.datos_generales.anio_inicio;
                        anioFin = this.datos_generales.anio_fin;
                    }
                    // LEGACY: ahora los anios de ppa se seleccionan uno a uno
                    // const anioInicio = this.ejecucion.ANIO_PPA_INI;
                    // const anioFin = this.ejecucion.ANIO_PPA_FIN;
                    const mesInicio = datos_generales.mes_inicio;
                   
                    // Filtra por año dentro del rango
                    if (anio < anioInicio || anio > anioFin) return false;
                    
                    if (mes){
                      
                      // Si es el primer año, aplica también el filtro de mes
                      if (anio === anioInicio && mes < mesInicio) return false;
                      
                      // Si es el íltimo año, aplica el filtro del mes a la inversa
                      if (anioInicio!=anioFin &&  anio === anioFin && mes >= mesInicio) return false;
                    }
                    return true;
                  })"
                  :key="index">
            <td>{{ fila.anio }}</td>
            <td>
              <input :disabled="disabled" type="text"
                     :value="formatNumber(fila.ppa1)"
                     @input="e => { const v=e.target.value.replace(',', '.'); fila.ppa1=Number(v); validarCampo(fila,'ppa1'); }"
                     class="campo"/>
            </td>
            <td>
              <input :disabled="disabled" type="text"
                     :value="formatNumber(fila.ppa2)"
                     @input="e => { const v=e.target.value.replace(',', '.'); fila.ppa2=Number(v); validarCampo(fila,'ppa2'); }"
                     class="campo"/>
            </td>
            <td>
              <input :disabled="disabled" type="text"
                     :value="formatNumber(fila.ppa3)"
                     @input="e => { const v=e.target.value.replace(',', '.'); fila.ppa3=Number(v); validarCampo(fila,'ppa3'); }"
                     class="campo"/>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    </div>
  </v-col>
  </v-row>
  </v-card>   
             
    </v-card>

</template>              





<script>
export default {
  props: {
    configuracion: {
      type: Array,
      required: true,
    },
    ppa_precio_compra_matrix: {
      type: Array,
      required: true,
    },
    perfiles: { // Recibe el valor desde el padre
      type: Object,
      required: true,
    }, 
    ejecucion: { // Recibe el valor desde el padre
      type: Object,
      required: true,
    },        
    venta_excedente:{
      type:Array,
      required:true,
    },
        datos_generales:{
      type:Object,
      required:true,
    },
  disabled: {
    type: Boolean,
    default: false,
  }
  },
  emits: ['update:configuracion', 'update:perfiles', 'update:venta_excedente', 'update:modoPcvppa'],
  data() {
    return {

      

      valid: false,
      datos: [...this.configuracion], // Crea una copia local de los datos
      local_perfiles: {...this.perfiles}, // Crea una copia local de los datos
      
      datos_excedente: [...this.venta_excedente],
      datos_compra: [...this.ppa_precio_compra_matrix],
      rules: {
        required: (v) => !!v || "Este campo es obligatorio",
        Negativo: (v) => {
        const num = Number(v.toString().replace(',', '.'));
          return isNaN(num) ? 'Valor inválido' : (num >= 0 ? true : 'El valor no puede ser negativo');
        },
      },
      columns_excedente:[
         {name: this.$t('comun.anio'),  prop: "anio", size: 90, readonly: true },
        { name: "PPA1",  prop: "ppa1", size: 250  },
        { name: "PPA2",  prop: "ppa2", size: 300  },
        { name: "PPA3",  prop: "ppa3", size: 250  },
      ]
      
    };
  },

  

  computed: {
    columns_compra(){
       let cols=[
        { name: this.$t('comun.anio'),  prop: "anio", size: 90, readonly: true },
        { name: "PPA1",  prop: "ppa1", size: 250  },
        { name: "PPA2",  prop: "ppa2", size: 300  },
        { name: "PPA3",  prop: "ppa3", size: 250  },
      ]
      // if ('activo' in this.datos_compra?.[0]){
      //   cols.push({ name: this.$t('simulacion.modulo.ppa_configuracion.activo'),  prop: "activo", size: 250  })
      // } 
      return cols
    },
    headers() {
      let baseHeaders = [
        { title: this.$t('simulacion.modulo.ppa_configuracion.ppa'), value: "ppa", align: "start", width: '10%' },
        { title: this.$t('simulacion.modulo.ppa_configuracion.pcio'), value: "pcio", align: "center", width: '20%' },
        { title: this.$t('simulacion.modulo.ppa_configuracion.horas'), value: "horas", align: "center", width: '20%' },
      ]
      if ('pcio_venta' in (this.datos?.[0])){
        baseHeaders = [
          { title: this.$t('simulacion.modulo.ppa_configuracion.ppa'), value: "ppa", align: "start", width: '10%' },                
          { title: this.$t('simulacion.modulo.ppa_configuracion.pcio'), value: "pcio", align: "center", width: '20%' },
          { title: this.$t('simulacion.modulo.ppa_configuracion.pcio_venta'), value: "pcio_venta", align: "center", width: '20%' },
          { title: this.$t('simulacion.modulo.ppa_configuracion.horas'), value: "horas", align: "center", width: '20%' },
        ]
      }
      
      /* if (this.ejecucion.OPC_PCPPA === 1) {
        baseHeaders = [
          { title: this.$t('simulacion.modulo.ppa_configuracion.ppa'), value: "ppa", align: "start", width: '10%' },                
          { title: this.$t('simulacion.modulo.ppa_configuracion.pcio'), value: "pcio", align: "center", width: '20%' },
          { title: this.$t('simulacion.modulo.ppa_configuracion.pcio_venta'), value: "pcio_venta", align: "center", width: '20%' },
          { title: this.$t('simulacion.modulo.ppa_configuracion.horas'), value: "horas", align: "center", width: '20%' },
        ]
      } */

      return baseHeaders
    },
    modoMinPoolExcedente() {
    return Number(this.ejecucion?.OPC_PCVPPA_MIN_POOL ?? 0) === 1
  },

  labelModoPcvppa() {
    return this.$t('simulacion.modulo.ppa_venta.modo_min_pool')
  }
  },


  watch: {
    datos: {
      handler(newDatos) {
        this.$emit("update:modelValue", newDatos); // Emite los cambios al padre
      },
      deep: true,
    },

    '$i18n.locale'() {     
      
      this.headers = [
          { title: this.$t('simulacion.modulo.ppa_configuracion.ppa'), value: "ppa", align: "start", width: '10%' },          
          { title: this.$t('simulacion.modulo.ppa_configuracion.pcio'), value: "pcio", align: "center", width: '20%' },          
          { title: this.$t('simulacion.modulo.ppa_configuracion.horas'), value: "horas", align: "center", width: '20%' },
        ]

      /* if (this.ejecucion.OPC_PCPPA === 1) {
        this.headers = [
          { title: this.$t('simulacion.modulo.ppa_configuracion.ppa'), value: "ppa", align: "start", width: '10%' },                
          { title: this.$t('simulacion.modulo.ppa_configuracion.pcio'), value: "pcio", align: "center", width: '20%' },
          { title: this.$t('simulacion.modulo.ppa_configuracion.pcio_venta'), value: "pcio_venta", align: "center", width: '20%' },
          { title: this.$t('simulacion.modulo.ppa_configuracion.horas'), value: "horas", align: "center", width: '20%' },
        ]
      } */

      this.columns_compra=[
        { name: this.$t('comun.anio'),  prop: "anio", size: 90, readonly: true },
        { name: "PPA1",  prop: "ppa1", size: 250  },
        { name: "PPA2",  prop: "ppa2", size: 300  },
        { name: "PPA3",  prop: "ppa3", size: 250  },
      ]
      //if ('activo' in this.datos_excedente?.[0]){
      //  this.columns_compra.push({ name: this.$t('simulacion.modulo.ppa_configuracion.activo'),  prop: "activo", size: 250  })
      //} 
      

      this.columns_excedente=[
        { name: this.$t('comun.anio'),  prop: "anio", size: 90, readonly: true },
        { name: "PPA1",  prop: "ppa1", size: 250  },
        { name: "PPA2",  prop: "ppa2", size: 300  },
        { name: "PPA3",  prop: "ppa3", size: 250  },
      ]

    },


  },




  methods: {
    actualizarModoPcvppa(valor) {
  this.$emit('update:modoPcvppa', valor ? 1 : 0)
},
           actualizarDatos(){
            console.log("Actualizar Datos PPACONF")
          this.datos=[...this.configuracion]
          //this.local_perfiles={...this.perfiles}
          this.datos_excedente= [...this.venta_excedente]
          this.datos_compra = [...this.ppa_precio_compra_matrix]
         
        },
    validarCampo(fila, campo) {
      if (fila[campo] < 0) {
        fila[campo] = 0;
        alert(this.$t('El valor no puede ser negativo'));
      }
    },
    guess_delimiter(headers) {
      return headers.split(',').length > headers.split(';').length ? ',' : ';';
    },

    exportToCSV(tipo) {  
      let matriz=[]
      let nombre=""
      let headers=[]
      let columnas
      if (tipo=="compra"){
        matriz=this.datos_compra
        nombre =  this.$t('simulacion.modulo.ppa_configuracion.pcio_compra').split(' ').slice(0,3).join(' ')
        
        columnas=[...this.columns_compra]
        columnas.push({ name: this.$t('simulacion.modulo.ppa_configuracion.activo1') ,  prop: "activo1" })
        columnas.push({ name: this.$t('simulacion.modulo.ppa_configuracion.activo2') ,  prop: "activo2" })
        columnas.push({ name: this.$t('simulacion.modulo.ppa_configuracion.activo3') ,  prop: "activo3"})
        headers = columnas.map((col) => col.name).join(";");
      }
      else{
        matriz= this.datos_excedente
        nombre =  this.$t('simulacion.modulo.ppa_configuracion.pcio_venta').split(' ').slice(0,3).join(' ')
        headers = this.columns_excedente.map((col) => col.name).join(";");
        columnas=this.columns_excedente
      }

      const rows = matriz.filter(d => {
                    const fecha_Str=d.anio.toString()
                    const partes = fecha_Str.split('-');
                    const anio = parseInt(partes[0]);
                    let mes = parseInt(partes[1]);
                     let anioFin
                    let anioInicio
                    if (this.ejecucion && 'ANIO_PPA_INI' in this.ejecucion){
                        anioInicio = this.ejecucion.ANIO_PPA_INI;
                        anioFin = this.ejecucion.ANIO_PPA_FIN;
                    }
                    else{
                        anioInicio = this.datos_generales.anio_inicio;
                        anioFin = this.datos_generales.anio_fin;
                    }
                    //Si no existe el mes en las partes separadas, se asigna a 1 para que el modo anual funcione tambien
                    //  Legacy
                    // const anioInicio = this.ejecucion.ANIO_PPA_INI;
                    // const anioFin = this.ejecucion.ANIO_PPA_FIN;
                    const mesInicio = this.datos_generales.mes_inicio;

                    // Filtra por año dentro del rango
                    if (anio < anioInicio || anio > anioFin) return false;
                    if (mes){
                      
                      // Si es el primer año, aplica también el filtro de mes
                      if (anio === anioInicio && mes < mesInicio) return false;
                      
                      // Si es el íltimo año, aplica el filtro del mes a la inversa
                      if (anioInicio!=anioFin &&  anio === anioFin && mes >= mesInicio) return false;
                    }
                    return true;
                  }).map((row) =>
        columnas.map((col) => 
                  {
                    //anio es la columna fecha
                    if (col.prop === 'anio') { 
                    return row[col.prop] || ""; 
                  } else {
                    return this.formatNumber(row[col.prop]) || "";
                  }
                  }
      
      ).join(";")
      );

      const csvContent = [headers, ...rows].join("\n");
      const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;

      //let nombre =  this.$t('simulacion.modulo.ppa_configuracion.pcio_venta').split(' ').slice(0,3).join(' ')
      nombre = nombre.toLowerCase().replace(/ /g, '_');
      //Para quitar tildes
      nombre=nombre.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
      a.download = nombre+".csv";
      a.click();
      URL.revokeObjectURL(url);
    },

    importFromCSVCompra() {
      this.$refs.fileInputCompra.click();
    },
    importFromCSVVenta() {
      this.$refs.fileInputVenta.click();
    },
  encontrarColumnasSobrantes(esperadas, recibidas) {
    const setEsperadas = new Set(esperadas);

    const sobrantes = recibidas.filter(columna => {
        // Devuelve las columnas recibidas que NO están en el Set de esperadas
        return !setEsperadas.has(columna);
    });

    return sobrantes;
    },
    handleCSVUpload(event, tipo) {
      const file = event.target.files[0];
      if (file) {
        
        const reader = new FileReader();
        reader.onload = (e) => {
          const csvData = e.target.result;
          const [headerLine, ...lines] = csvData
            .split("\n")
            .map((line) => line.trim())
            .filter((line) => line.length > 0); // Eliminar líneas vacías
          //console.log("Datos de csv: ", csvData.split('\n')[0])
          const delim = this.guess_delimiter(csvData.split('\n')[0])
          console.log("Delimitador: ", delim)
          //console.log("headerline: ", headerLine)
          const header=headerLine.split(delim);
          console.log("Headerline: ", header)
          //Revisar que las cabeceras estén bien, este es hidrógeno verde
          /* if( this.revisarCabeceras(header,true)){
            return
          } */
          //console.log("Lines : ", lines)
          const esperadas=[this.$t('comun.anio'),'PPA1','PPA2','PPA3']
          if (tipo=='compra'){
            esperadas.push(this.$t('simulacion.modulo.ppa_configuracion.activo1') )
            esperadas.push(this.$t('simulacion.modulo.ppa_configuracion.activo2') )
            esperadas.push(this.$t('simulacion.modulo.ppa_configuracion.activo3') )
          }
         const sobrantes= this.encontrarColumnasSobrantes(esperadas,header)
         console.log("sobrantes: ", sobrantes)
         if (sobrantes.length>0){
          alert(`Sobran las siguientes cabeceras: ${sobrantes.join(' ')}`);
          return
         }
          const nuevaLista = lines.map(obj => {
          const values = obj.split(";");
          const newobj = {};
          const cabeceras_prop={
            [this.$t('comun.anio')]:"anio",
            "PPA1":"ppa1",
            "PPA2":"ppa2",
            "PPA3":"ppa3",

          }
           if (tipo=='compra'){
            cabeceras_prop[this.$t('simulacion.modulo.ppa_configuracion.activo1')]='activo1'
            cabeceras_prop[this.$t('simulacion.modulo.ppa_configuracion.activo2')]='activo2'
            cabeceras_prop[this.$t('simulacion.modulo.ppa_configuracion.activo3')]='activo3'

          }
          for (let index = 0; index < header.length; index++) {
                const headerName = header[index];
                const value = values[index];

                // console.log("Value a asignar: ", value);
                const prop = cabeceras_prop[headerName];
                

                if (prop === "anio") {
                    // Revisar si tiene formato de dia-mes-año
                    const formatoDiaMesAnio = /^\d{2}\/\d{2}\/\d{4}$/;
                    
                    newobj[prop] = formatoDiaMesAnio.test(value)
                        ? (() => {
                            const [dd, mm, yyyy] = value.split("/");
                            return `${yyyy}-${mm}-${dd}`;
                        })()
                        : Number(value);
                } else if(prop) {
                    const cleanValue = value?.replace(',', '.');
                    // El operador ?? se asegura de que si value es null/undefined, se use una cadena vacía para el chequeo
                    const finalValue = cleanValue ?? ''; 
                    
                    // Verifica si es cadena vacía o NaN después de la limpieza
                    newobj[prop] = finalValue === "" || isNaN(finalValue) ? value : Number(finalValue);
                }
            }

            return newobj; 
          });
        //console.log("nuevaLista: ", nuevaLista)
        // Convertimos updatedData a un Map para acceso rápido por año
        const updatedMap = new Map(nuevaLista.map(item => [item.anio, item]));
        //console.log("Updated: ", updatedMap)
        const filteredMap = new Map(
            [...updatedMap.entries()].filter(([anio]) => {

              //console.log("Año: ", anio);
              return anio >= 2025 && anio <= 2100;
            })
          );
          console.log("Tipo: ", tipo)
        if (tipo=="compra"){
              const mergedData = this.datos_compra.map(item =>
            filteredMap.has(item.anio) ? filteredMap.get(item.anio) : ( /* console.log("No tiene ", item.anio, " ", typeof(item.anio))  ,*/ item)
            );
              this.datos_compra = [...mergedData];
              //console.log("Merged data: ", mergedData)
              this.$emit("update:ppa_precio_compra_matrix", this.datos_compra);
            }
          else if (tipo=="venta"){

           
            const mergedData = this.datos_excedente.map(item =>
            filteredMap.has(item.anio) ? filteredMap.get(item.anio) : ( /* console.log("No tiene ", item.anio, " ", typeof(item.anio))  ,*/ item)
            );
              this.datos_excedente = [...mergedData];
              //console.log("Merged data: ", mergedData)
              this.$emit("update:venta_excedente", this.datos_excedente);
            }
         }
        reader.readAsText(file, "UTF-8");
      }
      event.target.value = ""; // Reinicia el valor del input para permitir el mismo archivo
    },


    formatNumber(value) {
      if (value === null || value === undefined || value === '') return '';
      if (typeof value !== 'number') value = Number(value);

      // Si es entero, no ponemos decimales
      if (Number.isInteger(value)) {
        return value.toString().replace('.', ',');
      } else {
        // Si tiene decimales, mostramos con coma
        return value.toString().replace('.', ',');
      }
    },
    emitChanges() {
      // Permite realizar acciones adicionales al modificar un valor
    },
    guardarDatos() {
      console.log("Datos guardados:", this.datos);
    },
    calcular_horas(item){

      /*
      "ppa_configuracion": [ //Configuracion PPAs //cppfiaja depende de OPT_PPA
          {"ppa": "PPA1", "capmax": 1000, "pcio": 40, "horas": 2443, "cppafija": 100},
          {"ppa": "PPA2", "capmax": 1000, "pcio": 60, "horas": 3050, "cppafija": 50},
          {"ppa": "PPA3", "capmax": 0, "pcio": 10000, "horas": 8760, "cppafija": 0}                
        ],

      "perfiles": [
          {"periodo": 1, "ppa1": 0, "ppa2": 0, "ppa3": 0}
        ],         
      */

      //let columna = item.ppa.toLowerCase()
      //let num_horas = 0
      //num_horas = this.perfiles.filter((registro) => registro[columna] !== 0).length;      

      let columna = item.ppa.toLowerCase();
      let num_horas = this.perfiles.reduce((suma, registro) => suma + (registro[columna] || 0), 0);
      num_horas = parseFloat(num_horas.toFixed(1));
      return num_horas;


    }
  },
};
</script>

<style scoped>
.v-btn {
  margin-top: 20px;
}
.subtitulo-PPA{
  padding: 5px;
}
</style>

